var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DefaultWidgetField',_vm._g(_vm._b({attrs:{"hideTitle":_vm.hideTitle}},'DefaultWidgetField',_vm.defaultFieldProps,false),_vm.defaultFieldListeners)),_c('p',{ref:_vm.fieldRef,staticClass:"paragraph",domProps:{"innerHTML":_vm._s(_vm.cleanHtml)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }